// @flow
import { createSelector } from 'reselect';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import type { GlobalState } from '../rootReducer';
import { postForgotPassword } from '../api/auth';

/* Action Types */
export const FORGOT_PASSWORD_FAIL = 'la/ui/forgotPassword/FAIL';
export const FORGOT_PASSWORD_REQUEST = 'la/ui/forgotPassword/REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'la/ui/forgotPassword/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
    errorMessage: ?string,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case FORGOT_PASSWORD_REQUEST:
            return {
                ...state,
                error: false,
                errorMessage: null,
                submitted: true,
                success: false,
            };
        case FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };
        case FORGOT_PASSWORD_FAIL:
            return {
                ...state,
                error: true,
                errorMessage: action.payload.message,
                submitted: false,
                success: false,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.forgotPassword;

export const getUiForgotPassword = createSelector(stateSelector, state => state);

/* ACTION CREATORS */
export const submitForgotPassword = (emailAddress: string) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            payload: emailAddress,
            type: FORGOT_PASSWORD_REQUEST,
        });
        await postForgotPassword({ authToken, deployment, emailAddress });
        dispatch({
            payload: emailAddress,
            type: FORGOT_PASSWORD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { emailAddress },
            payload: error,
            type: FORGOT_PASSWORD_FAIL,
        });
    }
};
